// media-categories/components/media-categories-list.jsx
import {
  List,
  Datagrid,
  TextField,
  EditButton,
  DeleteButton,
  DateField,
  Create,
  Edit,
  SimpleForm,
  TextInput,
  SelectInput,
  Toolbar,
  SaveButton,
  BooleanInput,
  BooleanField,
  Filter,
  required,
} from "react-admin";

const MediaCategoriesFilter = (props) => (
  <Filter {...props}>
    <SelectInput 
      source="type" 
      choices={[
        { id: 'blog', name: 'Blog' },
        { id: 'gallery', name: 'Gallery' }
      ]} 
      alwaysOn 
    />
    <SelectInput 
      source="isActive" 
      choices={[
        { id: true, name: 'Active' },
        { id: false, name: 'Inactive' }
      ]} 
      alwaysOn 
    />
  </Filter>
);

export const MediaCategoriesList = (props) => {
  return (
    <List {...props} filters={<MediaCategoriesFilter />}>
      <Datagrid rowClick="edit">
        <TextField source="id" />
        <TextField source="name" />
        <TextField source="type" />
        <BooleanField source="isActive" label="Active" />
        <DateField source="createdAt" label="Created" showTime />
        <EditButton />
        <DeleteButton mutationMode="pessimistic" />
      </Datagrid>
    </List>
  );
};

export const MediaCategoriesCreate = (props) => (
  <Create title="Create Media Category" {...props} redirect="list">
    <SimpleForm>
      <TextInput 
        source="name" 
        label="Name" 
        fullWidth 
        validate={[required()]}
      />
      <SelectInput
        source="type"
        label="Type"
        choices={[
          { id: 'blog', name: 'Blog' },
          { id: 'gallery', name: 'Gallery' }
        ]}
        validate={[required()]}
      />
      <BooleanInput 
        source="isActive" 
        label="Active" 
        defaultValue={true}
      />
    </SimpleForm>
  </Create>
);

const MediaCategoriesEditToolbar = (props) => (
  <Toolbar {...props}>
    <SaveButton />
  </Toolbar>
);

export const MediaCategoriesEdit = (props) => (
  <Edit title="Edit Media Category" {...props}>
    <SimpleForm toolbar={<MediaCategoriesEditToolbar />}>
      <TextInput 
        source="name" 
        fullWidth 
        validate={[required()]}
      />
      <SelectInput
        source="type"
        label="Type"
        choices={[
          { id: 'blog', name: 'Blog' },
          { id: 'gallery', name: 'Gallery' }
        ]}
        validate={[required()]}
      />
      <BooleanInput 
        source="isActive" 
        label="Active" 
      />
    </SimpleForm>
  </Edit>
);